import { REQUEST_DASHBOARD, REQUEST_DASHBOARD_FAILURE, REQUEST_DASHBOARD_SUCCESS } from "../../constant/DashboardConstant";

const initialState = {
  dashboard: {
    data: [],
  },
};

export const dashboardReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case REQUEST_DASHBOARD:
      return {
        ...state,
        dashboard: {
          data: [],
          status: 'fetching',
          isLoading: true,
        },
      };
    case REQUEST_DASHBOARD_SUCCESS:
      return {
        ...state,
        dashboard: {
          data: payload,
          status: 'ready',
          isLoading: false,
        },
      };
    case REQUEST_DASHBOARD_FAILURE:
      return {
        ...state,
        dashboard: {
          data: [],
          status: 'failure',
          isLoading: false,
        },
      };
    default:
      return state;
  }
}